export default "__VITE_ASSET__XQl$boAC__"